import {Base} from "@/api/Base"

export class OvertimeApplicationList extends Base {
    path = "overtimeApplication/list"
}